import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hire-code-igniter-framework-dev',
  templateUrl: './hire-code-igniter-framework-dev.component.html',
  styleUrls: ['./hire-code-igniter-framework-dev.component.css']
})
export class HireCodeIgniterFrameworkDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/hire-code-igniter-framework-dev/hire-code-igniter-framework-dev.component.ts